import React from "react";

import styles from "./Dashboard.module.css";
import JobSummary from "../../components/Dashboard/JobWidget/JobSummary/JobSummary";
import JobOverview from "../../components/Dashboard/JobWidget/JobOverview/JobOverview";
import Page from "@atlaskit/page";
import JobStats from "../../components/Dashboard/JobStats/JobStats";
import StorageStats from "../../components/Dashboard/StorageStats/StorageStats";
import LicenseDetails from "../../components/Dashboard/LicenseDetails/LicenseDetails";

const Dashboard = (props) => {
  return (
    <Page>
      <div className={styles.container}>
        <>
          <div className={styles.headerCardMainContainer}>
            <JobStats appType={props.appType} />
            <StorageStats />
            <LicenseDetails />
          </div>
        </>
        <>
          <div className={styles.widgetContainer}>
            <JobSummary appType={props.appType} />
            <JobOverview appType={props.appType} />
          </div>
        </>
      </div>
    </Page>
  );
};

export default Dashboard;
